import Api from './baseApi';

export default {
  getMy: (onlyWarnings = false) => Api.get(`/api/CriticalStock/my?onlyWarnings=${onlyWarnings}`),
  saveMy: (items) => Api.put('/api/CriticalStock/my', items),
  getAll: (userId, onlyWarnings = false) => {
    const params = [];
    if (userId) params.push(`userId=${userId}`);
    params.push(`onlyWarnings=${onlyWarnings}`);
    return Api.get(`/api/CriticalStock/all?${params.join('&')}`);
  },
  canViewAll: () => Api.get('/api/CriticalStock/can-view-all'),
};
